module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Thin.ttf
// module id = 262
// module chunks = 0